import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    IgxAccordionModule,
    IgxActionStripModule,
    IgxAvatarModule,
    IgxButtonGroupModule,
    IgxButtonModule,
    IgxCalendarModule,
    IgxCardModule,
    IgxCheckboxModule,
    IgxChipsModule,
    IgxComboModule,
    IgxDatePickerModule,
    IgxDateRangePickerModule,
    IgxDialogModule,
    IgxDragDropModule,
    IgxDropDownModule,
    IgxGridModule,
    IgxHierarchicalGridModule,
    IgxIconModule,
    IgxInputGroupModule,
    IgxListModule,
    IgxMaskModule,
    IgxNavbarModule,
    IgxNavigationDrawerModule,
    IgxRadioModule,
    IgxRippleModule,
    IgxSelectModule,
    IgxSimpleComboModule,
    IgxSliderModule,
    IgxStepperModule,
    IgxSwitchModule,
    IgxTabsModule,
    IgxTextSelectionModule,
    IgxTimePickerModule,
    IgxToastModule,
    IgxToggleModule,
} from '@infragistics/igniteui-angular';
import { ColorPickerModule } from '@iplab/ngx-color-picker';
import { NgxEditorModule } from 'ngx-editor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthenticationInterceptor } from './authentication/authentication.interceptor';
import { RepeatInterceptor } from './authentication/repeat.interceptor';
import { AddDiscountComponent } from './base/add-discount/add-discount.component';
import { AddPackageComponent } from './base/add-package/add-package.component';
import { AddPaymentComponent } from './base/add-payment/add-payment.component';
import { EditEnrollmentsComponent } from './base/edit-enrollments/edit-enrollments.component';
import { EditKidFormComponent } from './base/edit-kid-form/edit-kid-form.component';
import { EditKidsComponent } from './base/edit-kids/edit-kids.component';
import { EditParentFormComponent } from './base/edit-parent-form/edit-parent-form.component';
import { EditParentsComponent } from './base/edit-parents/edit-parents.component';
import { EditProfilesComponent } from './base/edit-profiles/edit-profiles.component';
import { EditProgramsComponent } from './base/edit-programs/edit-programs.component';
import { InfoEnrollmentComponent } from './base/info-enrollment/info-enrollment.component';
import { InfoKidComponent } from './base/info-kid/info-kid.component';
import { InfoProgramComponent } from './base/info-program/info-program.component';
import { ProcessEnrollmentComponent } from './base/process-enrollment/process-enrollment.component';
import { SendEmailComponent } from './base/send-email/send-email.component';
import { SettingsComponent } from './base/settings/settings.component';
import { UserProfileComponent } from './base/user-profile/user-profile.component';
import { MessageComponent } from './message.component';
import { ActiveUserPipe } from './pipes/active-user.pipe';
import { HiddenPipe } from "./pipes/hidden.pipe";
import { SortingPipe } from './pipes/sorting.pipe';
import { SharedModule } from './shared/shared.module';
import { GroupComponent } from './views/group/group.component';
import { TransportComponent } from './views/transport/transport.component';

@NgModule({
    declarations: [
        AppComponent,
        AddDiscountComponent,
        AddPackageComponent,
        AddPaymentComponent,
        EditEnrollmentsComponent,
        EditKidFormComponent,
        EditKidsComponent,
        EditParentFormComponent,
        EditParentsComponent,
        EditProfilesComponent,
        EditProgramsComponent,
        GroupComponent,
        HiddenPipe,
        InfoEnrollmentComponent,
        InfoKidComponent,
        InfoProgramComponent,
        MessageComponent,
        ProcessEnrollmentComponent,
        SendEmailComponent,
        SettingsComponent,
        TransportComponent,
        UserProfileComponent,
        ActiveUserPipe,
        SortingPipe,
    ],
    bootstrap: [AppComponent], imports: [CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        HammerModule,
        ColorPickerModule,
        IgxAccordionModule,
        IgxActionStripModule,
        IgxAvatarModule,
        IgxButtonModule,
        IgxButtonGroupModule,
        IgxCalendarModule,
        IgxCardModule,
        IgxCheckboxModule,
        IgxChipsModule,
        IgxComboModule,
        IgxDatePickerModule,
        IgxDateRangePickerModule,
        IgxDialogModule,
        IgxDragDropModule,
        IgxDropDownModule,
        IgxGridModule,
        IgxHierarchicalGridModule,
        IgxIconModule,
        IgxInputGroupModule,
        IgxListModule,
        IgxMaskModule,
        IgxNavbarModule,
        IgxNavigationDrawerModule,
        IgxSelectModule,
        IgxSimpleComboModule,
        IgxSliderModule,
        IgxStepperModule,
        IgxRadioModule,
        IgxRippleModule,
        IgxSwitchModule,
        IgxTabsModule,
        IgxTextSelectionModule,
        IgxTimePickerModule,
        IgxToastModule,
        IgxToggleModule,
        NgxEditorModule,
        SharedModule], providers: [
            { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true },
            { provide: HTTP_INTERCEPTORS, useClass: RepeatInterceptor, multi: true },
            { provide: LOCALE_ID, useValue: 'bg' },
            provideHttpClient(withInterceptorsFromDi())
        ]
})
export class AppModule {
}
